/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1432
 */

var r = require(/* 2470 */"./2470")()
module.exports = r
